import {ref, watch} from 'vue'
import {defineStore} from 'pinia'

export const useMemberStore = defineStore('member', () => {
    const member = ref({
        "ID": 0,
        "bindMobile": false,
        "bindIdCard": false,
        "vip": 1,
        "money": "0",
        "gamegold": 0,
        "gamesilver": 0,
        "growthValue": 0,
        "vipParams": {},
        "nextVipParams": {},
        "shareCount": 0,
        "checkInLast": 0,
        "checkInDay": 0,
        "checkInGiftStatus": false,
        "isPromote": false,
        "cardWeek": 0,
        "cardMonth": 0,
        "lotteryCount": 0
    })
    const loginStatus = ref(false)
    const token = ref(window.localStorage.getItem('token') || '')
    const service = ref("")
    const serviceArr = ref([])
    const shareLink = ref(document.location.origin + "/?t=")
    const uuid = ref(window.localStorage.getItem('uuid') || '')

    watch(() => token.value, () => {
        window.localStorage.setItem('token', token.value)
    })

    watch(() => uuid.value, () => {
        window.localStorage.setItem('uuid', uuid.value)
    })

    return {member, loginStatus, token, service, serviceArr, shareLink, uuid}
})
